module.exports = __webpack_public_path__ + "media/V50.232ac474.mp4";